import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../../../core/auth/_services/auth.service';
import { PermissionType } from '../../../../core/auth/enums/permission.enum';

@Pipe({
    name: 'userHasPermission',
    pure: true,
})
export class UserHasPermissionPipe implements PipeTransform {
    constructor(private auth: AuthService) {
    }

    transform(permissionId: PermissionType): boolean {
        return this.auth.userHasPermission(permissionId);
    }
}